import React from 'react';
import styled from 'styled-components';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import { FontWeight } from 'lib/styles';
import { Background, Border, Text } from 'styles/themeColors';
import { currencySign } from 'utils/formatters';

const TableFooterColumn = styled.span`
  width: 200px;
  height: 20px;
  font-style: normal;
  font-weight: ${FontWeight.bold};
  color: ${Text.primary};
  font-size: 16px;
  line-height: 20px;
`;

const TableFooterData = styled.span`
  width: 104px;
  height: 20px;
  text-align: right;
  color: ${Text.primary};
  font-size: 16px;
  line-height: 20px;
`;

interface AffiliateSummaryProps {
  country: string | null;
  totalCommission: number;
}

const AffiliateSummary: React.FC<AffiliateSummaryProps> = ({ country, totalCommission }) => {
  return (
    <FlexboxContainerComponent flexDirection="column" alignItems="flex-end" width="100%" padding="16px">
      <FlexboxContainerComponent flexDirection="column" bgColor={Background.shaded} padding="16px" width="auto">
        <FlexboxContainerComponent padding="0 0 8px 0">
          <TableFooterColumn>Affiliate</TableFooterColumn>
        </FlexboxContainerComponent>
        <FlexboxContainerComponent borderTop={`1px solid ${Border.light}`} padding="8px 0 0 0">
          <TableFooterColumn style={{ fontWeight: 'normal' }}>Affiliate commission</TableFooterColumn>
          <TableFooterData>{currencySign(country, totalCommission)}</TableFooterData>
        </FlexboxContainerComponent>
      </FlexboxContainerComponent>
    </FlexboxContainerComponent>
  );
};

export default AffiliateSummary;
